import axios from "axios";
import { BASE_URL } from "./apiConfig";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/*
  Sessão morta derruba para o login.

  O token do staff vale 1 dia. Sem este interceptor, depois de expirar a
  pessoa ficava numa tela que carregava para sempre — toda chamada voltava
  403 e cada componente mostrava o próprio erro genérico, sem ninguém dizer
  "entre de novo".

  O 403 do login NÃO entra aqui: credencial errada não é sessão expirada, e
  recarregar a página de login em cima de quem está digitando esconderia a
  mensagem de erro.
*/
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const isLoginRequest = String(error.config?.url || "").includes("/login");

    if ((status === 401 || status === 403) && !isLoginRequest) {
      localStorage.removeItem("token");

      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login?expirada=1";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
